import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  loadCategory,
  loadAllCategories,
  setCategoryValue,
} from 'Store/Actions/marketplace'

import {
  getAllCategories,
  getLoadingAllCategories,
  getCategoryValue,
} from 'Store/Selectors/marketplace'

import List from './List'

const selector = createStructuredSelector({
  allCategories: getAllCategories,
  isLoadingAllCategories: getLoadingAllCategories,
  categoryValue: getCategoryValue,
})

const actions = {
  onLoadCategory: loadCategory,
  onLoadAllCategories: loadAllCategories,
  onSetCategoryValue: setCategoryValue,
}

export default connect(selector, actions)(List)
